module.exports = __webpack_public_path__ + "img/flecha-abajo.90307896.svg";